import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import CustomPagination from '../../../components/customPagination';
import { formatDate } from '../../../utils/formatDate';
import dayjs from 'dayjs';
import BulkPDFActionsMenu from './BulkPDFJobsActionsMenu';
const getReportStatusLabel = (status) => {
  const statusMap = {
    processed: 'Completed',
    failed: 'Failed',
    processing: 'Processing',
    queued: 'Queued',
  };

  return statusMap[status];
};
const BulkPDFJobsTable = ({ bulkPDFs, handlePaginationChange, totalJobs, loading }) => {
  const columns = [
    {
      field: 'created_at',
      headerName: 'Request Date',
      flex: 0.7,
      align: 'left',
      renderCell: (params) => dayjs.unix(params.row.created_at).format('YYYY-MM-DD hh:mm:ss A'),
    },
    {
      field: 'period',
      headerName: 'Period',
      flex: 1,
      align: 'left',
      renderCell: (params) => {
        const start = formatDate(params.row.filters?.start_date) || '';
        const end = formatDate(params.row.filters?.end_date) || '';
        return `${start} to ${end}`;
      },
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 0.6,
      align: 'left',
      id: 'report-status',
      renderCell: (params) => getReportStatusLabel(params.row.status.toLowerCase()),
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 0.5,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {
        const isProcessed = params.row.status?.toLowerCase() === 'processed';
        return <BulkPDFActionsMenu filePath={params.row.file_path} disabled={!isProcessed} />;
      },
    },
  ];
  return (
    <DataGrid
      rows={bulkPDFs}
      loading={loading}
      columns={columns}
      sx={{ mt: '1rem' }}
      getRowId={(row) => row._id}
      paginationMode="server"
      rowCount={totalJobs}
      initialState={{
        pagination: {
          paginationModel: {
            pageSize: 10,
          },
        },
      }}
      pageSizeOptions={[10, 25]}
      disableRowSelectionOnClick
      onPaginationModelChange={(model) => {
        console.log('model', model);
        handlePaginationChange(model.page + 1, model.pageSize);
      }}
      slots={{
        pagination: CustomPagination,
      }}
    />
  );
};

export default BulkPDFJobsTable;
